import React from 'react';
import { Alert, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import CommonTable from '../../../common/components/CommonTable';
import TransactionTableRow from './TransactionTableRow';

function TransactionTable({ data, offset, changeOffset }) {
  if (data?.items.length === 0) {
    return (
      <div className="alert-wrapper">
        <Alert color="info" className="mb-0">
          There is currently no data to show.
        </Alert>
      </div>
    );
  }

  return (
    <Col xs="12">
      <CommonTable
        className="settings-table settings-table--transactions"
        headerOptions={['Date', 'Transaction Type', 'Price']}
        rowComponent={TransactionTableRow}
        data={data}
        offset={offset}
        onOffsetChange={changeOffset}
        pagination={true}
      />
    </Col>
  );
}

TransactionTable.propTypes = {
  changeOffset: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  offset: PropTypes.number.isRequired,
};

export default TransactionTable;
